import React, { PureComponent } from 'react';
import { addUrlProps, UrlQueryParamTypes, RouterToUrlQuery} from 'react-url-query';
import { connect } from 'react-redux'
import { newquery } from '../services/actions'
import { withRouter } from 'react-router-dom'


const mapStateToProps = (state) => {
    return {
        query : state.urlquery
    }
};

const mapDispatchToProps = dispatch => {
    return {
        handleQuery: data => {dispatch(newquery(data))}
    }
};

var voidArray = [];
const participants = {
    decode: (encoded) => {
        if (encoded){
            var temp = JSON.parse(encoded);
            if (Array.isArray(temp)){
                return temp
            }
            else {
                return voidArray
            }
        }
        else{
            return voidArray
        }
    },
    encode: (decoded) => (decoded ? JSON.stringify(decoded) : JSON.stringify(voidArray)),
};

const urlPropsQueryConfig = {
    time: {type: UrlQueryParamTypes.string},
    date: {type: UrlQueryParamTypes.string},
    participants: { type: participants },
};

class LowerComponent extends PureComponent {
    componentWillMount(){
        this.props.handleQuery({participants : this.props.participants, time : this.props.time, date : this.props.date})
    }
    componentWillReceiveProps(props){
        if (props.query.updated){
            this.props.history.push("/");
        }
    }
    render() {
        return (
            <div>
                <span>{this.props.query.date}</span>
            </div>
        )
    }
}

const PassStore = withRouter(connect(mapStateToProps, mapDispatchToProps)(LowerComponent));

const PassQuery = addUrlProps({ urlPropsQueryConfig })(PassStore);

class QueryHandlerWraper extends PureComponent {
    render() {
        return (
            <RouterToUrlQuery>
                <PassQuery />
            </RouterToUrlQuery>
        )
    }
}

export default QueryHandlerWraper



// WEBPACK FOOTER //
// ./src/components/wtm_qry.cont.js